<template>
  <div
    class="file-uploader file__attach"
    @click="disabled ? undefined : $refs.document.click()"
  >
    <v-btn class="two-line" :disabled="disabled">
      <v-icon class="mr-2">mdi-camera</v-icon>
      выберите фото
    </v-btn>

    <div class="file-uploader__text"><slot/></div>
    <input
      type="file"
      class="d-none"
      ref="document"
      accept="image/*, application/pdf"
      @change="OnFilePicked"
    />
  </div>
</template>

<script>
export default {
  name: 'FileUploaderComponent',
  props: ['disabled'],
  methods: {
    /**
     * Добавление документа к продаже.
     * @param e эвент
     */
    OnFilePicked(e) {
      const app = this;
      const { files } = e.target;
      let document = { filename: '', base64: '' };
      if (files[0] !== undefined) {
        const [file] = files;
        if (file.name.lastIndexOf('.') <= 0) return;
        document.filename = file.name;
        const fr = new FileReader();
        fr.readAsDataURL(file);
        fr.addEventListener('load', () => {
          document.base64 = fr.result;
          app.$emit('click', { ...document });
        });
      } else {
        document = { filename: '', base64: '' };
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "src/assets/scss/variables";

.file-uploader {
  span {
    display: block;
    color: $sale-file-btn-color;
    font-size: 11px;
    line-height: 1.2;
    transition: color .3s ease;
  }
  &:hover {
    cursor: pointer;

    span {
      color:$sale-file-btn-hover-color;
      transition: color .3s ease;
    }
  }
}
</style>
